import { render, staticRenderFns } from "./orderCounts.vue?vue&type=template&id=1854cd18&scoped=true&"
import script from "./orderCounts.vue?vue&type=script&lang=js&"
export * from "./orderCounts.vue?vue&type=script&lang=js&"
import style0 from "./orderCounts.vue?vue&type=style&index=0&id=1854cd18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854cd18",
  null
  
)

export default component.exports